import"../../field/filled-field.js";import{literal as e}from"../../../../../../lit-html@3.2.1/node_modules/lit-html/static.js";import{Select as t}from"./select.js";/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */class s extends t{constructor(){super(...arguments),this.fieldTag=e`md-filled-field`}}export{s as FilledSelect};
